import React from 'react';
import { useDispatch } from 'react-redux';
import { updatePurchaseFlow } from '../../../../../reduxStore/navigation/actions';
import locales from '../../../../../content.json';
import s from './index.module.scss';

export const SkipBtn = () => {
  const dispatch = useDispatch();

  const togglePurchaseFlow = () => {
    dispatch(updatePurchaseFlow({}));
  };

  return (
    <div className={s.wrapper}>
      <button onClick={togglePurchaseFlow}>
        {locales[window.userLang].pdfUpselling_16}
      </button>
    </div>
  );
};
